export const BoatsScreen = () => {
  return <div>Boats screen!</div>
}
